import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import AllInOneIcon from "@images/about/all-in-one_outlined.svg"
import EcologyIcon from "@images/about/ecology.svg"
import TimelineIcon from "@images/about/timeline.svg"
import UserIcon from "@images/about/user.svg"
import Markdown from "@components/Markdown"
import CardWithIconTextDescriptionModule from "@modules/CardWithIconTextDescriptionModule"

const CharacteristicModule = () => {
  const { t } = useTranslation()

  const params = {
    elements: [
      {
        icon: AllInOneIcon,
        title: t("AboutMetaloop_Section4_Header1"),
        description: t("AboutMetaloop_Paragraph9"),
      },
      {
        icon: TimelineIcon,
        title: t("AboutMetaloop_Section4_Header2"),
        description: t("AboutMetaloop_Paragraph10"),
      },
      {
        icon: UserIcon,
        title: t("AboutMetaloop_Section4_Header3"),
        description: t("AboutMetaloop_Paragraph11"),
      },
      {
        icon: EcologyIcon,
        title: t("AboutMetaloop_Section4_Header4"),
        description: <Markdown>{t("AboutMetaloop_Paragraph12")}</Markdown>,
      },
    ],
  }
  return <CardWithIconTextDescriptionModule {...params} />
}

export default CharacteristicModule
